import "bootstrap";

export class NavBar{
    public static CheckWebGPU() : string{
        let result = 'Your current browser supports WebGPU!';
        if (!navigator.gpu) {
           result = `Your current browser does not support WebGPU! Make sure you are on a system 
                     with WebGPU enabled. Currently, SPIR-WebGPU is only supported in  
                     <a href="https://www.google.com/chrome/canary/">Chrome canary</a>
                     with the flag "enable-unsafe-webgpu" enabled. See the 
                     <a href="https://github.com/gpuweb/gpuweb/wiki/Implementation-Status"> 
                     Implementation Status</a> page for more details.                   
                    `;
        } 
        return result;
    }

    public static AddNavbar() {
        const navbar = `
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <a class="navbar-brand" href="/index.html">WebGPU Project</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
            
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                    <a class="nav-link" href="/index.html">Home <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link" href="/html/test.html">Test</a>
                    </li>
                    <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Chapter 2-4
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/html/ch02-triangle.html">Ch02: Triangle </a>
                        <a class="dropdown-item" href="/html/ch02-triangle-glsl.html">Ch02: GLSL Triangle</a> 
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/html/ch03-points.html">CH03: Points </a>
                        <a class="dropdown-item" href="/html/ch03-lines.html">Ch03: Lines</a>      
                        <a class="dropdown-item" href="/html/ch03-triangles.html">Ch03: Triangles</a>   
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/html/ch04-triangle-color.html">Ch04: Colored Triangle </a>
                        <a class="dropdown-item" href="/html/ch04-triangle-one-buffer.html">Ch04: Triangle: One Buffer</a>      
                        <a class="dropdown-item" href="/html/ch04-square.html">Ch04: Square</a>   
                        <a class="dropdown-item" href="/html/ch04-square-index.html">Ch04: Square with Index Buffer</a>      
                    </div>
                    </li>   
                    <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Chapter 5-7
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/html/ch05-transforms.html">Ch05: Transformations</a>
                        <a class="dropdown-item" href="/html/ch05-projection.html">Ch05: Projection</a>   
                        <div class="dropdown-divider"></div> 
                        <a class="dropdown-item" href="/html/ch06-line.html">Ch06: 3D Line</a>
                        <a class="dropdown-item" href="/html/ch06-cube.html">Ch06: Cube: Face Color</a>
                        <a class="dropdown-item" href="/html/ch06-cube-vertex-color.html">Ch06: Cube: Vertex Color</a>     
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/html/ch07-cube.html">Ch07: Cube Wireframe</a>   
                        <a class="dropdown-item" href="/html/ch07-sphere.html">Ch07: Sphere Wireframe</a> 
                        <a class="dropdown-item" href="/html/ch07-cylinder.html">Ch07: Cylinder Wireframe</a> 
                        <a class="dropdown-item" href="/html/ch07-cone.html">Ch07: Cone Wireframe</a>    
                        <a class="dropdown-item" href="/html/ch07-torus.html">Ch07: Torus Wireframe</a>                                            
                    </div>
                </li>
            
                </ul>               
                </div>
            </nav>
        `
        const div = document.getElementById('id_navbar') as HTMLDivElement;
        div.innerHTML = navbar;
    }
}
